import { NgModule } from '@angular/core';
import { SessaoExpiradaRoutingModule } from './sessao-expirada.routing.module';

import { 
  SessaoExpiradaComponent
} from './index.component';
import { SharedModule } from '@smdapp/shared';
import { NgSharedModule } from '@smdapp/ng-shared/ng-shared.module'
import { CommonModule } from '@angular/common';

@NgModule({
  imports: [SessaoExpiradaRoutingModule, NgSharedModule, SharedModule, CommonModule],
  declarations: [
  SessaoExpiradaComponent
  ]
})
export class SessaoExpiradaModule {}
